import { isAxiosError } from 'axios';

export interface ApiErrorInfo {
  status?: number;
  message: string;
}

/**
 * Normalize an unknown thrown value into a status code + human message.
 *
 * Sakti Go / the gateway return errors as `{ success: false, error: "..." }` with a
 * meaningful HTTP status (e.g. 409 when a sync is already running, 404 for a missing
 * job/table). Reading `err.response` lets callers branch on the status instead of
 * collapsing every failure into a generic "failed"
 */
export const extractApiError = (err: unknown): ApiErrorInfo => {
  if (isAxiosError(err)) {
    // FastAPI's own HTTPException puts the message in `detail` (string for 4xx we raise).
    const data = err.response?.data as
      | { error?: string; message?: string; detail?: unknown }
      | undefined;
    const detail = typeof data?.detail === 'string' ? data.detail : undefined;
    return {
      status: err.response?.status,
      message: data?.error ?? data?.message ?? detail ?? err.message,
    };
  }

  return { message: err instanceof Error ? err.message : 'Terjadi kesalahan tak terduga' };
};

export default extractApiError;
